/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotificaListItemDto } from '../../models/notifica-list-item-dto';

export interface ApiNotificaNotificaListGet$Params {
    /**
     * Indica se caricare le notifiche archiviate (default: NO)
     */
    isArchiviata?: boolean;
}

export function apiNotificaNotificaListGet(
    http: HttpClient,
    rootUrl: string,
    params?: ApiNotificaNotificaListGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<NotificaListItemDto>>> {
    const rb = new RequestBuilder(rootUrl, apiNotificaNotificaListGet.PATH, 'get');
    if (params) {
        rb.query('isArchiviata', params.isArchiviata, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<NotificaListItemDto>>;
        }),
    );
}

apiNotificaNotificaListGet.PATH = '/api/notifica/notifica-list';
